export const IossNumberValidation = 'IM\\d{10}';
export const EoriNumberGbValidation = '^(GB[0-9]{12}|GBUNREG)$';
export const EoriNumberValidation = '^[A-Z]{2}.{8,15}$';
